import { api } from './client';

export const goalsAPI = {
  list: (params) => api.get('/goal-races/', { params }),
  create: (data) => api.post('/goal-races/', data),
  update: (id, data) => api.patch(`/goal-races/${id}/`, data),
  delete: (id) => api.delete(`/goal-races/${id}/`),
  deleteAll: (params) => api.delete('/goal-races/delete-all/', { params }),
};

export const resultsAPI = {
  list: (params) => api.get('/race-results/', { params }),
  create: (data) => api.post('/race-results/', data),
  update: (id, data) => api.patch(`/race-results/${id}/`, data),
  delete: (id) => api.delete(`/race-results/${id}/`),
};